const debug = require('debug')('xmtk:can');
// Helper functions that can be shared between multiple roles.

const isSameClient = (user, { clientId }) => {
  if (clientId) {
    return clientId === user.clientId;
  }
  return false;
};

const isSelf = (user, { id }) => {
  if (id) {
    return id === user.id;
  }
  return false;
};

const roles = {
  admin: {
    allAccess: true,
  },
  client: {
    lockers: {
      index: true,
      show: true,
      available: true,
      assign: true,
    },
    orders: {
      index: true,
      show: true,
      export: true,
      notification: true,
      create: true,
      update: true,
      reversal: true,
      cancel: true,
    },
    clients: {
      show: true,
    },
    users: {
      index: true,
      show: true,
      create: true,
      update: true,
    },
    units: {
      index: true,
      show: true,
      create: true,
      update: true,
      delete: true,
    },
    segments: {
      index: true,
      show: true,
      create: true,
      update: true,
      delete: true,
    },
    reports: {
      index: true,
      show: true,
      create: true,
      delete: true,
    },
    products: {
      index: true,
      show: true,
      create: true,
      update: true,
      delete: true,
    },
  },
  viewer: {
    lockers: {
      index: true,
      show: true,
      available: true,
    },
    orders: {
      index: true,
      show: true,
      export: true,
    },
    reports: {
      index: true,
      show: true,
    },
    users: {
      index: true,
      show: isSelf,
      update: isSelf,
    },
  },
  manager: {
    lockers: {
      index: true,
      show: true,
      available: true,
      assign: true,
    },
    orders: {
      index: true,
      show: true,
      export: true,
      notification: true,
      create: true,
      update: true,
      reversal: true,
      cancel: true,
    },
    users: {
      index: true,
      show: isSelf,
      update: isSelf,
    },
    units: {
      index: true,
      show: true,
      create: true,
      update: true,
      delete: true,
    },
    reports: {
      index: true,
      show: true,
      create: true,
      delete: true,
    },
  },
  courier: {
    users: {
      update: isSelf,
    },
    orders: {
      index: true,
      show: true,
    },
  },
};

export const can = (user, operation, resource, params) => {
  const role = user.role;
  debug('can', role, operation, resource);
  if (!roles[role]) {
    debug('no role');
    return false;
  }

  const perm = roles[role];
  debug(perm);

  // If this role has access to everything
  if (perm.allAccess) {
    debug(true);
    return true;
  }

  // If this role has this resource
  if (perm[resource] && perm[resource][operation]) {
    // If it is a function, call it
    if (perm[resource] && typeof perm[resource][operation] === 'function') {
      debug(perm[resource][operation](user, params));
      return perm[resource][operation](user, params);
    }

    // Otherwise return the boolean
    debug(perm[resource] && perm[resource][operation]);
    return perm[resource] && perm[resource][operation];
  }

  // Otherwise deny access
  debug(false);
  return false;
};
